import { render } from "./Bußgeldkatalog.vue?vue&type=template&id=382d8936&scoped=true&ts=true"
import script from "./Bußgeldkatalog.vue?vue&type=script&lang=ts"
export * from "./Bußgeldkatalog.vue?vue&type=script&lang=ts"

import "./Bußgeldkatalog.vue?vue&type=style&index=0&id=382d8936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382d8936"]])

export default __exports__